import MemberState from "../enums/member-state.ts";
import LogUtils from "../utils/log-utils.ts";
import GroupState from "../enums/group-state.ts";
import Group from "../models/group.ts";
import State from "./state.ts";
import Restaurant from "../models/restaurant.ts";

export default class StateUtils {
  /**
   * TODO
   */
  public static getCurrentGroupId(state: State): string {
    // get the current group ID
    const groupId: string | null = state.groupState.currentGroupId;
    if (groupId === null) {
      LogUtils.error("attempted to get the current group's ID, but it hasn't been set yet");
    }

    // success
    return groupId;
  }

  /**
   * TODO
   */
  public static getCurrentGroup(state: State): Group {
    // get the current group ID
    const groupId: string = this.getCurrentGroupId(state);

    // get the current group
    const group: Group | null = state.groupState.getGroupById(groupId);
    if (group === null) {
      LogUtils.error(
        "attempted to get the current group, but no group has been stored with an ID matching 'currentGroupId'",
      );
    }

    // success
    return group;
  }

  /**
   * TODO
   */
  public static getCurrentGroupCode(state: State): string {
    // get the current group
    const group: Group = this.getCurrentGroup(state);

    // get the current group's Code
    const groupCode: string | null = group.code;
    if (groupCode === null) {
      LogUtils.error("attempted to get the current group's code, but it doesn't have one");
    }

    // success
    return groupCode;
  }

  /**
   * TODO
   */
  public static getCurrentGroupTopRestaurants(state: State): Restaurant[] {
    // get the current group
    const group: Group = this.getCurrentGroup(state);

    const topRestaurants: Restaurant[] | null = group.topRestaurants;
    if (topRestaurants === null) {
      LogUtils.error(
        "attempted to get the current group's top restaurants, but the current group doesn't have this data yet",
      );
    }

    // success
    return topRestaurants;
  }

  /**
   * Returns true if the new MemberState is one step further down the state tree than the original MemberState.
   * Returns false if the MemberState stays the same value, goes backwards along the state tree, or jumps too far ahead.
   */
  public static isNewMemberStateValid(originalMemberState: MemberState, newMemberState: MemberState): boolean {
    switch (newMemberState) {
      case MemberState.JOINED: {
        // MemberState is initialized as this - cannot update to the same value it already was
        return false;
      }
      case MemberState.SUBMITTED_RESTAURANT_CATEGORY_PREFERENCES: {
        // only: JOINED -> SUBMITTED_RESTAURANT_CATEGORY_PREFERENCES
        if (originalMemberState !== MemberState.JOINED) {
          return false;
        }
        break;
      }
      case MemberState.SUBMITTED_RESTAURANT_PREFERENCES: {
        // only: SUBMITTED_RESTAURANT_CATEGORY_PREFERENCES -> SUBMITTED_RESTAURANT_PREFERENCES
        if (originalMemberState !== MemberState.SUBMITTED_RESTAURANT_CATEGORY_PREFERENCES) {
          return false;
        }
        break;
      }
      default: {
        // unknown enum variant
        LogUtils.error(`unknown MemberState: ${newMemberState}`);
      }
    }

    // the new MemberState makes sense compared to the original MemberState
    return true;
  }

  /**
   * Returns true if the new GroupState is one step further down the state tree than the original GroupState.
   * Returns false if the GroupState stays the same value, goes backwards along the state tree, or jumps too far ahead.
   */
  public static isNewGroupStateValid(originalGroupState: GroupState, newGroupState: GroupState): boolean {
    switch (newGroupState) {
      case GroupState.NEW: {
        // GroupState is initialized as this - cannot update to the same value it already way
        return false;
      }
      case GroupState.READIED_UP: {
        // only: NEW -> READIED_UP
        if (originalGroupState !== GroupState.NEW) {
          return false;
        }
        break;
      }
      case GroupState.RECEIVED_ALL_RESTAURANT_CATEGORY_PREFERENCES: {
        // only: READIED_UP -> RECEIVED_ALL_RESTAURANT_CATEGORY_PREFERENCES
        if (originalGroupState !== GroupState.READIED_UP) {
          return false;
        }
        break;
      }
      case GroupState.RECEIVED_ALL_RESTAURANT_PREFERENCES: {
        // only: RECEIVED_ALL_RESTAURANT_CATEGORY_PREFERENCES -> RECEIVED_ALL_RESTAURANT_PREFERENCES
        if (originalGroupState !== GroupState.RECEIVED_ALL_RESTAURANT_CATEGORY_PREFERENCES) {
          return false;
        }
        break;
      }
      default: {
        // unknown enum variant
        LogUtils.error(`unknown GroupState: ${newGroupState}`);
      }
    }

    // the new GroupState makes sense compared to the original GroupState
    return true;
  }
}
